import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import { Case } from '../../../../shared/api/hscan/case';
import { MobileCheckboxWithText } from '../../common/components/CheckboxWithText';
import { ImageView } from '../../common/components/ImageView';
import {
  MobileTable,
  MobileTableRow,
} from '../../common/components/MobileTable';
import { TableAndElementInformation } from '../../common/components/SortableTable/PresentationalTable';
import { useModalityLabel } from '../../hooks/modalityHook';
import { MobileImageTable as ImageListTable } from '../ImageList/MobileImageTable';

const ElementContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: fit-content;
  border-radius: 8px;
  overflow: hidden;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex: 1;
  border: 1px solid #f5f5f5;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
`;

const CheckboxContainer = styled.div`
  background-color: white;
  padding: 15px;
`;

const NameContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
  font-weight: bold;
  font-size: 14px;
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  background-color: white;
  height: 164px;
  box-sizing: border-box;
  padding: 12px;
  border-right: 1px solid #f5f5f5;
  border-left: 1px solid #f5f5f5;
`;

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface MobileImageTableElementProps
  extends TableAndElementInformation<Case, 'caseId'> {}
export const MobileImageTableElement = (
  props: MobileImageTableElementProps,
) => {
  const { element, identifyKey, isSelected, isSelectable, onSelect } = props;
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.sendImages.imageTable',
  });
  const modalityLabel = useModalityLabel();

  return (
    <ElementContainer>
      <HeaderContainer>
        <CheckboxContainer>
          <MobileCheckboxWithText
            disabled={!isSelectable}
            value={isSelected}
            onChange={e => onSelect?.(element[identifyKey], e)}
            text={`${t('row.select')}`}
          />
        </CheckboxContainer>
        <NameContainer>{element.patientName ?? ''}</NameContainer>
      </HeaderContainer>
      <ImageContainer>
        <ImageView height="100%" imageId={element.contentIds?.[0] ?? ''} />
      </ImageContainer>
      <MobileTable>
        <tbody>
          <MobileTableRow label={`${t('header.institutionName')}`}>
            {element.institutionName ?? ''}
          </MobileTableRow>
          <MobileTableRow label={`${t('header.studyDate')}`}>
            {element.studyDate ?? ''}
          </MobileTableRow>
          <MobileTableRow label={`${t('header.modality')}`}>
            {modalityLabel(element.modality)}
          </MobileTableRow>
          <MobileTableRow label={`${t('header.bodyPart')}`}>
            {element.bodyPart?.join(', ') ?? ''}
          </MobileTableRow>
        </tbody>
      </MobileTable>
    </ElementContainer>
  );
};

export const MobileImageTable = () => {
  return <ImageListTable Element={MobileImageTableElement} />;
};
